import disposableDomainsJson from "../data/disposable-email-domains.json";

const DISPOSABLE = new Set(
  Array.isArray(disposableDomainsJson)
    ? disposableDomainsJson.map((d) => String(d).toLowerCase())
    : [],
);

export function getEmailDomain(email) {
  const trimmed = String(email).trim().toLowerCase();
  const at = trimmed.lastIndexOf("@");
  if (at < 1 || at === trimmed.length - 1) return null;
  return trimmed.slice(at + 1);
}

export function isDisposableEmail(email) {
  const domain = getEmailDomain(email);
  if (!domain) return false;
  if (DISPOSABLE.has(domain)) return true;
  const parts = domain.split(".");
  for (let i = 0; i < parts.length - 1; i++) {
    const sub = parts.slice(i).join(".");
    if (DISPOSABLE.has(sub)) return true;
  }
  return false;
}
